import Navbar from 'components/navbar'
import Layout, { Textlayout } from 'components/layout'
import Pagetitle from 'components/pageTitle'
import Footer from 'components/footer'
import CategorieSlider from 'components/shop/categorieSlider'
import CategoriePreview from '@/components/shop/categoriePreview'
import Seo from 'components/seo'

import { getHomeCollectionsAndProducts } from 'lib/shop/api/products'

export default function shopIndex({ collections }) {
  return (
    <>
      <Seo title="Boutique" description="" canonical="/shop" />
      <div className="overflow-hidden">
        <Navbar />
        <main className="relative mt-12 md:mt-24">
          <Layout>
            <Pagetitle>E-shop</Pagetitle>

            <div className="mt-8">
              <Textlayout>
                <div className="space-y-4 text-justify text-lg leading-tight">
                  <p>
                    Sur notre boutique, vous pourrez vous procurer tout ce dont vous avez besoin pour assurer une
                    cohérence visuelle sur vos réseaux sociaux. De l'organisation visuelle de votre Instagram aux photos
                    parfaitement retouchées, vous êtes à un clic d'un compte professionnel! Prêt à sauter le pas ?
                  </p>
                </div>
              </Textlayout>
            </div>
          </Layout>

          <div className="mt-24">
            <CategorieSlider
              collections={collections.filter(
                ({ node: thisCollections }) => thisCollections.showInSlider?.value === 'true'
              )}
            />
          </div>

          <div className="mt-24">
            {collections.map(({ node: thisCollection }, index) => {
              const shouldHaveBg = (index + 1) % 2

              return (
                <CategoriePreview
                  key={thisCollection.id}
                  title={thisCollection.title}
                  shouldHaveBg={shouldHaveBg}
                  products={thisCollection.products.edges}
                  href={`/shop/categorie/${thisCollection.handle}`}
                />
              )
            })}
          </div>
        </main>
        <div className="mt-32">
          <Footer />
        </div>
      </div>
    </>
  )
}

export async function getStaticProps() {
  const collections = await getHomeCollectionsAndProducts()

  // const categories = shopData.categories.map((thisCategories) => {
  //   if (thisCategories.products.length == 0) {
  //     return { ...thisCategories }
  //   }

  //   const shuffledProducts = thisCategories.products.sort(() => 0.5 - Math.random())
  //   const threeRandomProducts = shuffledProducts.slice(0, 3)

  //   const hydratateProducts = threeRandomProducts.map((thisProductId) => products.find((el) => el.id == thisProductId))

  //   return {
  //     ...thisCategories,
  //     products: hydratateProducts
  //   }
  // })

  return {
    props: {
      collections: collections.edges.sort(
        (a, b) => parseInt(a.node.order?.value || 999) - parseInt(b.node.order?.value || 999)
      )
    },
    revalidate: 60 * 5
  }
}
